var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseService } from './base.service';
import { Subject } from 'rxjs';
import { TokenService } from '../token.service';
import { AuthorizationService } from '../authorization.service';
import { MessageService } from '../message.service';
import { CacheService } from '../cache.service';
import { HttpClient } from '@angular/common/http';
import { DateHelper } from '../../utils/date-helper';
import { StorageService } from '../storage.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../authorization.service";
import * as i3 from "../message.service";
import * as i4 from "../cache.service";
import * as i5 from "../storage.service";
import * as i6 from "../token.service";
var ReservationService = /** @class */ (function (_super) {
    __extends(ReservationService, _super);
    function ReservationService(http, authorization, messages, cache, storage, tokenService) {
        var _this = _super.call(this, http, authorization, messages, cache) || this;
        _this.storage = storage;
        _this.tokenService = tokenService;
        _this.endpointUri = 'Reservations';
        return _this;
    }
    ReservationService.prototype.getAll = function () {
        throw new Error('Method not implemented.');
    };
    ReservationService.prototype.get = function (id) {
        return this.getRequest(id);
    };
    ReservationService.prototype.getMyCurrent = function () {
        return this.getAllRequest(null, [
            { key: nameof('PersonId'), value: String(this.storage.getPersonId()) },
            { key: nameof('DateTimeFrom'), value: String(DateHelper.getUnixTime(new Date())) }
        ]);
    };
    /**
     * Create new Reservation
     *
     * @param {Reservation} entity
     * @returns {Observable<any>}
     * @memberof ReservationService
     */
    ReservationService.prototype.add = function (entity, headers) {
        return this.addRequest(null, entity, headers);
    };
    /**
     * Change reservation
     *
     * @param {Reservation} entity
     * @returns {Observable<any>}
     * @memberof ReservationService
     */
    ReservationService.prototype.update = function (entity) {
        return this.updateRequest(String(entity.ReservationId), null, entity, []);
    };
    ReservationService.prototype.delete = function (id) {
        return this.deleteRequest(id);
    };
    /**
     * Load reservation template containing information from sdk etc.
     *
     * @param {string} idRessource
     * @returns {Observable<Reservation>}
     * @memberof ReservationService
     */
    ReservationService.prototype.getTemplate = function (idRessource) {
        return this.getRequest(idRessource, this.endpointUri + '/templates');
    };
    ReservationService.prototype.getIcsLink = function (idReservation) {
        var _this = this;
        var obs = new Subject();
        // load file token
        this.tokenService.getFileToken()
            .subscribe(function (token) {
            var link = _this.apiBaseUrl + '/' + _this.endpointUri + '/' + String(idReservation) + '/calendar.ics?token=' + token.access_token;
            // push link
            obs.next(link);
        }, function (err) { obs.error(err); }, function () { obs.complete(); });
        return obs;
    };
    ReservationService.ngInjectableDef = i0.defineInjectable({ factory: function ReservationService_Factory() { return new ReservationService(i0.inject(i1.HttpClient), i0.inject(i2.AuthorizationService), i0.inject(i3.MessageService), i0.inject(i4.CacheService), i0.inject(i5.StorageService), i0.inject(i6.TokenService)); }, token: ReservationService, providedIn: "root" });
    return ReservationService;
}(BaseService));
export { ReservationService };
